export const deidentificationFaqs = [
    {
        question: "Why is Obfuscation used for de-identification of the RWE DataLab unstructured data instead of traditional redaction?",
        answer: [
            {
                type: 'segments',
                segments: [
                    "Obfuscation improves readability (including interpretation by large language models) and may offer a higher protection than redaction ",
                    { text: "Carrell et al. (2012)", href: "https://pubmed.ncbi.nlm.nih.gov/22771529/" },
                    ", ",
                    { text: "Carrell et al. (2020)", href: "https://pubmed.ncbi.nlm.nih.gov/32930712/" },
                    ". The Obfuscation solution for direct identifiers, such as names, leverages the same >99% detection rate required for traditional redaction (replacement with a string indicating that text has been redacted). However, in Obfuscation, residual outlier names not detected by the algorithm remain ambiguous as to whether they are real or synthetic from the perspective of a recipient of the data."
                ]
            }
        ]
    },
    {
        question: "Is the obfuscated/synthesized name based on the ethnicity of the original abstracted name? Ex. If a found name was Fernando, would the engine replace it with another name of similar ethnicity or a completely random name?",
        answer: [
            {
                type: 'paragraph',
                text: "The name is replaced based on a dataset of the most common names in the United States. It is not coherent with the ethnicity/race of the patient. However, please note that this current constraint is factored into the analysis performed to evaluate the efficacy of Obfuscation as a privacy preserving measure."
            }
        ]
    },
    {
        question: "How is the researcher assured that all patient and/or provider names have been Obfuscated/synthesized?",
        answer: [
            {
                type: 'paragraph',
                text: "This detection rate is measured for each dataset undergoing Expert Determination by Datavant's Privacy Solutions' team of privacy analysts who are experts at assessing the risk content of unstructured data. Identifiers are required to be neutralized at a rate exceeding 99% for de-identification. If the privacy analyst team measures a smaller rate for a given dataset, further finetuning and testing of the Obfuscation solution is undertaken until this requirement is satisfied. When the threshold is met, this is documented in the Expert Determination certifying the data as de-identified. It is worth emphasizing that no detection algorithm is guaranteed to reach 100% efficacy in all circumstances. This protection is quantitatively estimated through statistical methods described in Privacy Solution's Expert Determination reports."
            }
        ]
    },
    {
        question: "Regarding the availability of synthesized names in the Obfuscated unstructured data, is IRB approval required for research purposes?",
        answer: [
            {
                type: 'paragraph',
                text: "Under U.S. research ethics and privacy frameworks, IRB oversight depends on whether a dataset contains information about identifiable living individuals. When the dataset has been de-identified in accordance with HIPAA through an Expert Determination, downstream use of the data is generally not considered human subjects research, and IRB review is not required. However, some institutions may still request an administrative \"not human subjects research\" determination for documentation purposes. The use of synthetic names does not, by itself, trigger IRB requirements or create human subjects research."
            }
        ]
    },
    {
        question: "How are dates handled within the de-identification engine when performing Obfuscations?",
        answer: [
            {
                type: 'paragraph',
                text: "The following modifications are applied to unstructured data:"
            },
            {
                type: 'bullets',
                items: [
                    "Dates in records where patient birth indicators are detected are aggregated to year-level.",
                    "Dates in records where patient death indicators are detected are aggregated to year-level.",
                    "All other dates remain unmodified."
                ]
            },
            {
                type: 'paragraph',
                text: "For further clarification:"
            },
            {
                type: 'bullets',
                items: [
                    "Dates associated with a patient/patient's activities can be considered an indirect identifier but their risk contribution is considered to be \"very small\" and is accounted for in the overall risk quantification without need for modification - except in the enhanced risk scenarios described above.",
                    "Dates in the current year do not typically require different treatment than other dates (although in certain cases they may carry a different weight in our risk calculations).",
                    "Originally, all dates were redacted in the data. Upgrades to the model over the years have allowed us to preserve the vast bulk of dates and only modify those which carry significant risk (as described above)."
                ]
            }
        ]
    },
    {
        question: "Does Obfuscation of the unstructured date create any inconsistencies between dates within the structured data?",
        answer: [
            {
                type: 'paragraph',
                text: "The current treatment of dates in Obfuscation of the unstructured data mirrors the structured data, in which date of birth and date of death are aggregated to year-level but other dates (including dates and times associated with diagnosis history, medication history, etc.) remain unmodified. Thus, inconsistencies between dates within the unstructured data or between the unstructured and structured datasets should not be incurred by the Obfuscation methods. Dates which are aggregated lose some granularity (going from e.g., 08/06/2023 to 2023) but there is no inaccuracy incurred. The majority of dates are low risk and not modified at all."
            }
        ]
    }
];
